<template>
  <div class="loading" v-if="mostrar" :style="[cor]"></div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      color: {
        type: String,
        default: '#c2c5c7'
      },
      size: {
        type: String,
        default: 'is-small'
      }
    },
    data () {
      return {
        cor: {
          borderColor: 'transparent transparent ' + this.color + ' ' + this.color + ' !important'
        }
      }
    },
    computed: {
      mostrar () {
        return this.loading
      }
    }
  }
</script>

<style scoped>
  .loading:after {
    border-color: transparent transparent #0a0a0a #0a0a0a !important;
    webkit-animation: spinAround 500ms infinite linear;
    animation: spinAround 500ms infinite linear;
    border: 2px solid #dbdbdb;
    border-radius: 290486px;
    content: "";
    display: block;
    position: relative;
    height: 1em;
    width: 1em;
    left: calc(50% - (1em / 2));
    top: calc(50% - (1em / 2));
    box-sizing: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/PortalLoadingSmall.vue